import { WebWorkerMessageHandler } from '../../../../core/web-workers/web-worker-message-handler.model';
import { Store } from '@ngrx/store';
import * as fromCop from 'src/app/modules/cop/store/cop/cop.actions';
import { LoggerService } from 'src/app/modules/core/services/logger/logger.service';
import { Logger, LogLevel } from 'src/app/modules/core/services/logger/logger.model';

export class ProcessWorkflowChangeEventHandler implements WebWorkerMessageHandler {
  private logger: Logger;

  public constructor(private store$: Store, private loggerService: LoggerService) {
    this.logger = this.loggerService.getLogger('WebworkerClient.ProcessWorkflowChangeEventHandler');
  }

  processMessage(payload: any): void {
    const stopWatch = this.logger.startStopwatch(LogLevel.Info, 'ProcessWorkflowChangeEventHandler.processMessage()');

    if (!!payload) {
      setTimeout(() => {
        this.store$.dispatch(fromCop.processSignalRWorkflowChangeEvent({ event: payload }));
      }, 1);
    }

    stopWatch.stop();
  }
}
